import PropTypes from 'prop-types';
import React from 'react';
import InputWithIcon from 'components/InputWithIcon';
import {injectIntl, defineMessages} from 'react-intl';
import Icon from 'components/Icon.js';
import uniq from 'lodash/uniq';
import flatMap from 'lodash/flatMap';
import ColumnSelectItem, {ExpandableColumnSelectItem} from './ColumnSelectItem';

const getIsSingleDataSource = columns =>
  uniq(flatMap(columns, 'dataSourceIds')).length === 1;

const messages = defineMessages({
  filter: {
    defaultMessage: 'Filter Columns',
    description: 'Search placeholder for filtering a list of columns',
    id: 'ColumnSelect__FilterLabel',
  },
});

class ColumnSelect extends React.Component {
  state = {filter: ''};

  handleColumnSelect = (column, dataSourceId, filterType) => {
    this.props.onSelect(column, dataSourceId, filterType);
  };

  handleSearchChange = filter => {
    this.setState({
      filter,
    });
  };

  render() {
    const {columns, intl} = this.props;
    const pattern = new RegExp(this.state.filter, 'i');
    const isSingleDataSource = getIsSingleDataSource(columns);

    const ItemComponent = isSingleDataSource
      ? ColumnSelectItem
      : ExpandableColumnSelectItem;

    const columnEls = columns
      .filter(column => column.name.match(pattern))
      .map(column => (
        <ItemComponent
          key={column.name + '-' + column.dataSourceId}
          column={column}
          onSelect={this.handleColumnSelect}
        />
      ));

    return (
      <div>
        <InputWithIcon
          icon={<Icon icon={Icon.OPTIONS.SEARCH} />}
          onInputChange={this.handleSearchChange}
          placeholder={intl.formatMessage(messages.filter)}
        />
        {columnEls}
      </div>
    );
  }
}

ColumnSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  columns: PropTypes.array.isRequired,
};

export default injectIntl(ColumnSelect);
